import { Injectable } from '@angular/core';
import { Fees } from '../../models/course.models';

@Injectable({
	providedIn: 'root',
})
export class FeesAndFundingService {
	editFeesAndFunding(fees: Fees[], sortAscend: boolean): [string, number][][] {
		// [...Set of different Amounts values that exist] - Ensures duplicates are removed and stored in an array
		const amountCollection = [...new Set(fees.map((i) => i.price))];

		// Of the amount left in the set, push an array with an empty string for each in the amountCollection array
		const mutableFeesArr: any = [];
		amountCollection.forEach(() => mutableFeesArr.push(['']));

		// For each item in the params.arrFees
		for (let i = 0; i < fees.length; i++) {
			// Check each unique amountCollection
			for (let j = 0; j < amountCollection.length; j++) {
				// If the given params.arrFees amount === the amountCollection amount
				if (fees[i].price === amountCollection[j]) {
					// Push the amount && concat to the '' the locale_name property
					mutableFeesArr[j].push(fees[i].price);
					mutableFeesArr[j][0] = mutableFeesArr[j][0].concat(
						`${fees[i].region}, `,
					);
					// Spread the items and create a new set to remove duplicates
					mutableFeesArr[j] = [...new Set(mutableFeesArr[j])];
				}
				// String build is complete and now remove the final trailing comma and space
				if (i === fees.length - 1)
					mutableFeesArr[j][0] = mutableFeesArr[j][0].slice(
						0,
						mutableFeesArr[j][0].length - 2,
					);
			}
		}
		return this.sortFees(mutableFeesArr, sortAscend);
	}

	sortFees(
		editedFees: Array<Array<[string, number]>>,
		sortAscend: boolean,
	): [string, number][][] {
		if (sortAscend) {
			return editedFees.sort(
				(a: Array<[string, number]>, b: Array<[string, number]>) =>
					Number(a[1]) - Number(b[1]),
			);
		}
		return editedFees.sort(
			(a: Array<[string, number]>, b: Array<[string, number]>) =>
				Number(b[1]) - Number(a[1]),
		);
	}
}
